// extracted by mini-css-extract-plugin
export default {"overlay":"Cw-z","bodyOpen":"Dw-z","content":"Ew-z","header":"Fw-z","close":"Gw-z","closeNoHeading":"Hw-z"};